import React from 'react';
import { Container, Col } from 'react-bootstrap';

function ExternalLinks () {

    return (
        <Container className="pb-4">
            <h1>Useful Links</h1>
            <Col>
                <p class="noLink">
                    <a href="http://www.cbe.org.eg/en/Pages/default.aspx">The Central Bank of Egypt</a><br/>
                    <a href="https://moic.gov.eg/page/governance">Egypt's Ministry of International Cooperation </a><br/>
                    <a href="http://www.investinegypt.gov.eg/english/Pages/default.aspx">Invest in Egypt</a><br/>
                    <a href="http://www.usegyptcouncil.org/">US Egypt Business Council</a><br/>
                    <a href="https://www.amcham.org.eg/">American Chamber of Commerce</a><br/>
                    <a href="https://egyptembassy.net/consular-services/egyptian-consulate-in-us/">Consulate General of Egypt in New York</a><br/>
                    <a href="http://www.egyptembassy.net/">Embassy of Egypt, Washington D.C.</a><br/>
                    <a href="https://opengov.unescwa.org/node/1212">Egyptian Government Services</a><br/>
                    <a href="http://www.egypt.travel/en">Explore Egypt</a><br/>
                    <a href="https://www.nbe.com.eg/NBE/E/#/EN/ProductCategory?inParams=%7B%22CategoryID%22%3A%22DonationID%22%7D">Donate to Egypt Community</a><br/>
                    &nbsp;<br/>
                    &nbsp;<br/>
                    Disclaimer: We provide these links to external websites for your convenience. NBE-NY does not endorse and is not responsible for their content, links, privacy policies, or security policies.
                </p>
            </Col>
        </Container>
    )
}

export default ExternalLinks;